// ECMJ - gidan.kang
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { ASSET_RESOURCE_DIVISION_CODE } from '@ecp/common/src/const/asset';

import myAssetPointApi from '@mo-apis/myPage/myAssetPointApi';

import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import useAssetPoint from '@ecp/common/src/hooks/asset/useAssetPoint';
import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';
import { NumberFormat } from '@ecp/common/src/utils/utils';

const GnbPoint = () => {
  const location = useLocation();
  const { displayPointName, priceFormat } = useSiteInfo();
  const { getAssetTypeIcon, getAssetUnit } = useAssetPoint();
  const priceUtils = new PriceUtils();

  const [point, setPoint] = useState([]);

  const pointCode = ASSET_RESOURCE_DIVISION_CODE.SUPPORT; // 복지포인트

  const fetchMySummary = useCallback(async () => {
    const { result } = await myAssetPointApi.summary();

    const supportPoint = result
      .filter((item) => item.assetResourceDivisionCode === pointCode)
      .map((item) =>
        item.assetResourceDivisionCode === pointCode
          ? { ...item,
            assetDivisionName: displayPointName,
            displayAssetBalance: priceUtils.getDisplayPrice({
              priceFormat,
              price: NumberFormat(item.assetBalance ?? 0),
              formattedPrice: NumberFormat(item.assetFormattedBalance ?? 0),
            })}
          : item
      )[0];
    setPoint(supportPoint);
  }, []);

  useEffect(() => {
    (async () => await fetchMySummary())();
  }, [location.pathname]);

  return (
    <>
      <TotalAmountContainer>
        <FlexBox align-items="center">
        </FlexBox>
        <FlexBox align-items="flex-end">
          <AssetTypeIcon image={getAssetTypeIcon(point?.assetResourceDivisionCode)} />
          <Spacing right={6} />
          <TextBox size={14} weight="350" height="100%" style={{ marginBottom: '3px' }}>
            {point?.assetDivisionName}
          </TextBox>
          <Spacing right={6} />
          <TextBox size={22} weight="700" height="100%">
            {point?.displayAssetBalance ?? 0}
          </TextBox>
          <Spacing right={6} />
          <TextBox size={14} weight="350" height="100%" style={{ marginBottom: '3px' }}>
            {getAssetUnit(point?.assetResourceDivisionCode)}
          </TextBox>
        </FlexBox>
      </TotalAmountContainer>
    </>
  );
};

const AssetTypeIcon = styled.div`
  width: 20px;
  height: 20px;
  background: url(${({ image }) => image}) no-repeat center;
  background-size: contain;
`;

const TotalAmountContainer = styled(FlexBoxSpaceBetween)`
  padding: 0 15px;
  align-self: stretch;
`;

export default GnbPoint;
